module.exports = __webpack_public_path__ + "assets/aca5485971995c83dc6b9adbce9598bd.svg";